(function () {
  'use strict';

  var cache = {};
  var debounceTimer = null;
  var abortController = null;
  var clickListenerAdded = false;

  /* ── Local fallback index ── */
  var fallbackIndex = null;
  var fallbackLoading = false;
  var fallbackQueue = [];

  function loadFallbackIndex(cb) {
    if (fallbackIndex) { cb(fallbackIndex); return; }
    fallbackQueue.push(cb);
    if (fallbackLoading) return;
    var url = window.searchFallbackUrl;
    if (!url) { cb([]); return; }
    fallbackLoading = true;
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        fallbackIndex = data;
        fallbackQueue.forEach(function (fn) { fn(data); });
        fallbackQueue = [];
      })
      .catch(function () {
        fallbackIndex = [];
        fallbackQueue.forEach(function (fn) { fn([]); });
        fallbackQueue = [];
      });
  }

  function searchFallback(index, query) {
    var terms = query.toLowerCase().trim().split(/\s+/).filter(function (t) { return t.length > 0; });
    if (!terms.length) return [];
    var results = [];
    var seenTitles = {};
    for (var i = 0; i < index.length; i++) {
      var entry = index[i];
      // Skip entries without price or image (drafts, link de pagamento, etc.)
      if (!entry[3] || entry[3] === '0' || entry[3] === '0.00' || !entry[5]) continue;
      var haystack = (entry[0] + ' ' + entry[1] + ' ' + entry[2]).toLowerCase();
      var allMatch = true;
      for (var j = 0; j < terms.length; j++) {
        if (haystack.indexOf(terms[j]) === -1) { allMatch = false; break; }
      }
      if (allMatch) {
        // Dedup by normalized title
        var normTitle = entry[1].toLowerCase().trim();
        if (seenTitles[normTitle]) continue;
        seenTitles[normTitle] = true;
        results.push({
          handle: entry[0],
          title: entry[1],
          url: '/products/' + entry[0],
          price: entry[3],
          compare_at_price: entry[4],
          image: entry[5] ? 'https://cdn.shopify.com/s/files/1/0671/3357/1268/files/' + entry[5] : '',
          available: entry[6] != null ? entry[6] : true,
          _fallback: true
        });
      }
    }
    return results;
  }

  /* Cache for product verification (draft check + availability) */
  var productVerifyCache = {};

  function verifyFallbackProducts(fallbackProducts, callback) {
    var verified = [];
    if (fallbackProducts.length === 0) { callback(verified); return; }

    var promises = fallbackProducts.map(function (product) {
      var handle = product.handle;
      // Use cache if available
      if (productVerifyCache[handle] !== undefined) {
        if (productVerifyCache[handle]) {
          product.image = productVerifyCache[handle].image || product.image;
          product.available = productVerifyCache[handle].available;
          verified.push(product);
        }
        return Promise.resolve();
      }

      // Two parallel fetches: product JSON (draft check + image) and availability section (inventory check)
      var jsonUrl = '/products/' + handle + '.json';
      var availUrl = '/products/' + handle + '?section_id=product-availability-check';

      return Promise.all([
        fetch(jsonUrl).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }),
        fetch(availUrl).then(function (r) { return r.ok ? r.text() : null; }).catch(function () { return null; })
      ])
        .then(function (results) {
          var jsonData = results[0];
          var availHtml = results[1];

          if (!jsonData || !jsonData.product) {
            productVerifyCache[handle] = null;
            return;
          }

          var pp = jsonData.product;
          var liveImg = pp.image ? pp.image.src : '';
          var isAvail = true;

          if (availHtml) {
            var match = availHtml.match(/"available"\s*:\s*(true|false)/);
            if (match) {
              isAvail = match[1] === 'true';
            }
          }

          productVerifyCache[handle] = { image: liveImg, available: isAvail };
          if (liveImg) product.image = liveImg;
          product.available = isAvail;
          verified.push(product);
        })
        .catch(function () {
          productVerifyCache[handle] = null;
        });
    });

    Promise.all(promises).then(function () { callback(verified); });
  }

  function mergeLocalFallback(products, query, callback) {
    loadFallbackIndex(function (index) {
      var localResults = searchFallback(index, query);
      if (!localResults.length) { callback(products); return; }

      // Verify fallback products: filter drafts (404), get live availability
      verifyFallbackProducts(localResults, function (verified) {
        var existingHandles = {};
        var existingTitles = {};
        var merged = [];
        products.forEach(function (p) {
          existingHandles[p.handle] = true;
          existingTitles[(p.title || '').toLowerCase().trim()] = true;
          merged.push(p);
        });
        for (var i = 0; i < verified.length; i++) {
          var lr = verified[i];
          var normTitle = (lr.title || '').toLowerCase().trim();
          if (existingHandles[lr.handle] || existingTitles[normTitle]) continue;
          merged.push(lr);
          existingHandles[lr.handle] = true;
          existingTitles[normTitle] = true;
        }
        merged = rankProducts(merged, query);
        if (merged.length > 5) merged = merged.slice(0, 5);
        callback(merged);
      });
    });
  }

  function init() {
    var inputs = document.querySelectorAll('.search__input');
    inputs.forEach(function (input) {
      if (input.dataset.instantSearchBound) return;
      input.dataset.instantSearchBound = '1';

      var wrapper = input.closest('.field') || input.closest('form');
      if (!wrapper) return;

      wrapper.style.position = 'relative';

      var dropdown = wrapper.querySelector('.search-instant-dropdown');
      if (!dropdown) {
        var tpl = document.querySelector('#search-instant-dropdown');
        if (tpl) {
          dropdown = tpl.cloneNode(true);
          dropdown.removeAttribute('id');
          dropdown.classList.add('search-instant-dropdown');
          wrapper.appendChild(dropdown);
        }
      }
      if (!dropdown) return;

      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(debounceTimer);
        if (q.length < 2) {
          showBestsellersOnly(dropdown);
          return;
        }
        debounceTimer = setTimeout(function () {
          fetchResults(q, dropdown, input);
        }, 250);
      });

      input.addEventListener('focus', function () {
        var q = input.value.trim();
        if (q.length >= 2 && dropdown.querySelector('.search-instant-dropdown__item')) {
          openDropdown(dropdown);
        } else {
          showBestsellersOnly(dropdown);
        }
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeDropdown(dropdown);
        }
      });
    });

    if (!clickListenerAdded) {
      clickListenerAdded = true;
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.search-instant-dropdown') && !e.target.closest('.search__input')) {
          document.querySelectorAll('.search-instant-dropdown').forEach(function (d) {
            closeDropdown(d);
          });
        }
      });
    }
  }

  function showBestsellersOnly(dropdown) {
    var resultsSection = dropdown.querySelector('.search-instant-dropdown__section--results');
    var bestsellersSection = dropdown.querySelector('.search-instant-dropdown__section--bestsellers');
    var emptyEl = dropdown.querySelector('.search-instant-dropdown__empty');
    var footerEl = dropdown.querySelector('.search-instant-dropdown__footer');
    var loadingEl = dropdown.querySelector('.search-instant-dropdown__loading');

    if (loadingEl) loadingEl.style.display = 'none';
    if (resultsSection) resultsSection.style.display = 'none';
    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'none';

    if (bestsellersSection) {
      bestsellersSection.style.display = 'block';
      openDropdown(dropdown);
    } else {
      closeDropdown(dropdown);
    }
  }

  /* Search terms → { handle, sku } to pin at position 1 */
  var pinnedMap = {
    'cadeira de banho': { handle: 'cadeira-de-banho-simples-sc103-aco-desmontavel-com-rodizios-100kg-hidrolight', sku: '29837' }
  };

  function getPinned(query) {
    var q = query.toLowerCase().trim();
    var keys = Object.keys(pinnedMap);
    for (var i = 0; i < keys.length; i++) {
      if (q.indexOf(keys[i]) !== -1) return pinnedMap[keys[i]];
    }
    return null;
  }

  function fetchResults(query, dropdown, input) {
    var key = query.toLowerCase().replace(/\s+/g, '-');

    if (cache[key]) {
      renderResultsWithFallback(cache[key], query, dropdown, input);
      return;
    }

    showLoading(dropdown);

    if (abortController) {
      abortController.abort();
    }
    abortController = new AbortController();

    var baseUrl = (window.routes && window.routes.predictive_search_url)
      ? window.routes.predictive_search_url
      : '/search/suggest';
    var searchUrl = baseUrl +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[limit]=5' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,tag,vendor,product_type,variants.title,variants.sku' +
      '&resources[options][prefix]=last';

    var pinInfo = getPinned(query);

    var mainFetch = fetch(searchUrl, { signal: abortController.signal }).then(function (res) { return res.json(); });

    // If there's a pinned product, fetch it directly in parallel
    var pinFetch = pinInfo
      ? fetch('/products/' + pinInfo.handle + '.json', { signal: abortController.signal })
          .then(function (res) { return res.json(); })
          .catch(function () { return null; })
      : Promise.resolve(null);

    Promise.all([mainFetch, pinFetch])
      .then(function (results) {
        var data = results[0];
        var pinData = results[1];

        if (pinInfo && pinData && pinData.product) {
          var pp = pinData.product;
          var pinnedProduct = {
            title: pp.title,
            handle: pp.handle,
            url: '/products/' + pp.handle,
            available: pp.available,
            price: pp.variants && pp.variants[0] ? pp.variants[0].price : pp.price,
            compare_at_price: pp.variants && pp.variants[0] ? pp.variants[0].compare_at_price : pp.compare_at_price,
            image: pp.image ? pp.image.src : (pp.images && pp.images[0] ? pp.images[0].src : ''),
            vendor: pp.vendor,
            type: pp.product_type
          };

          var products = (data.resources && data.resources.results && data.resources.results.products) || [];

          // Remove if already present to avoid duplicates
          products = products.filter(function (p) { return p.handle !== pinInfo.handle; });

          // Insert pinned product at position 0
          products.unshift(pinnedProduct);
          if (products.length > 5) products.pop();

          if (data.resources && data.resources.results) {
            data.resources.results.products = products;
          }
        }

        cache[key] = data;
        renderResultsWithFallback(data, query, dropdown, input);
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') {
          closeDropdown(dropdown);
        }
      });
  }

  /* Check real availability for all products via Liquid section */
  function checkAllAvailability(products, callback) {
    var pending = products.length;
    if (pending === 0) { callback(products); return; }

    products.forEach(function (product) {
      var handle = product.handle;
      if (!handle) { pending--; if (pending === 0) callback(products); return; }

      // Use cache
      if (productVerifyCache[handle] !== undefined && productVerifyCache[handle] !== null) {
        product.available = productVerifyCache[handle].available;
        pending--;
        if (pending === 0) callback(products);
        return;
      }

      fetch('/products/' + handle + '?section_id=product-availability-check')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html) {
            var match = html.match(/"available"\s*:\s*(true|false)/);
            if (match) {
              var isAvail = match[1] === 'true';
              product.available = isAvail;
              if (productVerifyCache[handle]) {
                productVerifyCache[handle].available = isAvail;
              } else {
                productVerifyCache[handle] = { image: null, available: isAvail };
              }
            }
          }
        })
        .catch(function () {})
        .then(function () {
          pending--;
          if (pending === 0) callback(products);
        });
    });
  }

  function renderResultsWithFallback(data, query, dropdown, input) {
    var products = [];
    if (data.resources) {
      products = (data.resources.results && data.resources.results.products) || data.resources.products || [];
    }
    mergeLocalFallback(products, query, function (merged) {
      var augmented = JSON.parse(JSON.stringify(data));
      if (augmented.resources && augmented.resources.results) {
        augmented.resources.results.products = merged;
      } else if (augmented.resources) {
        augmented.resources.products = merged;
      }
      // Render immediately, then update sold-out status async
      renderResults(augmented, query, dropdown, input);
      updateSoldOutStatus(dropdown);
    });
  }

  /* Post-render: check availability for ALL displayed products, then reorder */
  function updateSoldOutStatus(dropdown) {
    var resultsContainer = dropdown.querySelector('.search-instant-dropdown__results');
    if (!resultsContainer) return;
    var items = Array.from(resultsContainer.querySelectorAll('.search-instant-dropdown__item'));
    if (!items.length) return;

    var pending = items.length;
    var soldOutItems = [];
    var inStockItems = [];

    items.forEach(function (item) {
      var link = item.getAttribute('href') || '';
      var handleMatch = link.match(/\/products\/([^?]+)/);
      if (!handleMatch) { pending--; inStockItems.push(item); checkDone(); return; }
      var handle = handleMatch[1];

      // Check cache first
      if (productVerifyCache[handle] !== undefined && productVerifyCache[handle] !== null) {
        if (productVerifyCache[handle].available === false) {
          markSoldOut(item);
          soldOutItems.push(item);
        } else {
          inStockItems.push(item);
        }
        pending--;
        checkDone();
        return;
      }

      // Fetch availability via Liquid section
      fetch('/products/' + handle + '?section_id=product-availability-check')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html) {
            var match = html.match(/"available"\s*:\s*(true|false)/);
            if (match) {
              var isAvail = match[1] === 'true';
              productVerifyCache[handle] = productVerifyCache[handle] || { image: null, available: isAvail };
              productVerifyCache[handle].available = isAvail;
              if (!isAvail) {
                markSoldOut(item);
                soldOutItems.push(item);
                return;
              }
            }
          }
          inStockItems.push(item);
        })
        .catch(function () { inStockItems.push(item); })
        .then(function () { pending--; checkDone(); });
    });

    function checkDone() {
      if (pending > 0) return;
      // Reorder: in-stock first, sold-out last
      var container = items[0].parentElement;
      if (!container) return;
      inStockItems.forEach(function (item) { container.appendChild(item); });
      soldOutItems.forEach(function (item) { container.appendChild(item); });
    }
  }

  function markSoldOut(item) {
    item.classList.add('search-instant-dropdown__item--sold-out');
    var priceEl = item.querySelector('.search-instant-dropdown__item-price');
    if (priceEl) {
      priceEl.innerHTML = '<span class="search-instant-dropdown__sold-out-tag">Esgotado</span>';
    } else {
      var infoEl = item.querySelector('.search-instant-dropdown__item-info');
      if (infoEl) {
        infoEl.insertAdjacentHTML('beforeend', '<div class="search-instant-dropdown__item-price"><span class="search-instant-dropdown__sold-out-tag">Esgotado</span></div>');
      }
    }
  }

  function rankProducts(products, query) {
    if (!products.length) return products;
    var fullQ = query.toLowerCase().trim();
    var terms = fullQ.split(/\s+/).filter(function (t) { return t.length > 1; });
    if (!terms.length) return products;

    return products.slice().sort(function (a, b) {
      // Two-tier sort: in-stock products ALWAYS before out-of-stock
      var aOut = isSoldOutProduct(a);
      var bOut = isSoldOutProduct(b);
      if (aOut !== bOut) return aOut ? 1 : -1;
      // Within same tier, sort by relevance score
      return scoreProduct(b, terms, fullQ) - scoreProduct(a, terms, fullQ);
    });
  }

  function isSoldOutProduct(product) {
    if (product.available === false) return true;
    var handle = product.handle || (product.url || '').replace(/.*\/products\//, '').split('?')[0];
    var cached = handle && productVerifyCache[handle];
    if (cached && cached.available === false) return true;
    return false;
  }

  var ACCESSORY_PREFIXES = ['roda ', 'par ', 'apoio ', 'estrutura ', 'rodizio ', 'suporte ', 'encosto ', 'assento ', 'garfo ', 'bateria ', 'carregador ', 'chicote ', 'caixa ', 'kit ', 'estofamento ', 'almofada '];
  var ACCESSORY_KEYWORDS = ['anti tombo', 'anti-tombo', 'antitombo', 'bateria ', 'carregador ', 'chicote', 'garfo dianteiro', 'caixa-case', 'conector'];

  function scoreProduct(product, terms, fullQuery) {
    var title = (product.title || '').toLowerCase();
    var score = 0;

    // Title starts with the query
    if (title.indexOf(fullQuery) === 0) score += 50;

    // Title starts with first search term
    if (title.indexOf(terms[0]) === 0) score += 20;

    // Full query appears in title (earlier = better)
    var pos = title.indexOf(fullQuery);
    if (pos !== -1) score += 10 + Math.max(0, 20 - pos);

    // Each term: match + position bonus (earlier in title = better)
    // Missing term: heavy penalty
    terms.forEach(function (term) {
      var termPos = title.indexOf(term);
      if (termPos !== -1) {
        score += 1;
        score += Math.max(0, 10 - Math.floor(termPos / 5));
      } else {
        score -= 20;
      }
    });

    // Penalize accessories: titles starting with part/accessory words
    for (var i = 0; i < ACCESSORY_PREFIXES.length; i++) {
      if (title.indexOf(ACCESSORY_PREFIXES[i]) === 0) { score -= 30; break; }
    }

    // Penalize accessories: titles containing accessory keywords anywhere
    for (var i = 0; i < ACCESSORY_KEYWORDS.length; i++) {
      if (title.indexOf(ACCESSORY_KEYWORDS[i]) !== -1) { score -= 25; break; }
    }

    // Penalize if first search term appears very late in title
    var mainTermIdx = title.indexOf(terms[0]);
    if (mainTermIdx > 15) score -= 10;

    // Penalize outlet/clearance products
    if (title.indexOf('outlet') !== -1) score -= 5;

    return score;
  }

  function renderResults(data, query, dropdown, input) {
    var resultsSection = dropdown.querySelector('.search-instant-dropdown__section--results');
    var resultsContainer = dropdown.querySelector('.search-instant-dropdown__results');
    var bestsellersSection = dropdown.querySelector('.search-instant-dropdown__section--bestsellers');
    var emptyEl = dropdown.querySelector('.search-instant-dropdown__empty');
    var footerEl = dropdown.querySelector('.search-instant-dropdown__footer');
    var loadingEl = dropdown.querySelector('.search-instant-dropdown__loading');

    loadingEl.style.display = 'none';
    resultsContainer.innerHTML = '';

    var products = [];
    if (data.resources) {
      products = (data.resources.results && data.resources.results.products) || data.resources.products || [];
    }

    products = rankProducts(products, query);

    if (products.length === 0) {
      if (resultsSection) resultsSection.style.display = 'none';
      emptyEl.style.display = 'block';
      footerEl.style.display = 'none';
      if (bestsellersSection) bestsellersSection.style.display = 'block';
      openDropdown(dropdown);
      return;
    }

    emptyEl.style.display = 'none';
    if (resultsSection) resultsSection.style.display = 'block';
    if (bestsellersSection) bestsellersSection.style.display = 'block';

    products.forEach(function (product) {
      // Extract image URL first
      var imgSrc = '';
      if (product.image) {
        imgSrc = typeof product.image === 'string'
          ? product.image
          : (product.image.url || product.image.src || '');
      } else if (product.featured_image) {
        imgSrc = typeof product.featured_image === 'string'
          ? product.featured_image
          : (product.featured_image.url || product.featured_image.src || '');
      }

      // Extract price
      var productPrice = product.price || product.price_min || 0;
      var rawCents = productPrice;
      if (typeof rawCents === 'string') rawCents = rawCents.replace('.', '');
      rawCents = Number(rawCents) || 0;
      var hasValidPrice = rawCents > 0;

      // Skip products without actual image or valid price (drafts, invalid)
      if (!imgSrc || !hasValidPrice) {
        // Allow sold-out products that have an image
        if (!(product.available === false && imgSrc)) return;
      }

      if (imgSrc && imgSrc.indexOf('_120x') === -1) {
        imgSrc = imgSrc.replace(/(\.[^.?]+)(\?.*)?$/, '_120x$1$2');
      }

      var isSoldOut = product.available === false;

      var priceHtml = '';
      if (isSoldOut) {
        priceHtml = '<span class="search-instant-dropdown__sold-out-tag">Esgotado</span>';
      } else if (hasValidPrice) {
        var pixCents = Math.round(rawCents * 0.9);
        priceHtml = '<strong style="color:#16a34a">' + formatMoney(pixCents) + '</strong>' +
          '<small style="opacity:.6;margin-left:3px">à vista</small>';
      }

      var soldOutClass = isSoldOut ? ' search-instant-dropdown__item--sold-out' : '';

      var itemHtml = '<a href="' + product.url + '" class="search-instant-dropdown__item' + soldOutClass + '">' +
        '<div class="search-instant-dropdown__item-image">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="56" height="56">' : '') +
        '</div>' +
        '<div class="search-instant-dropdown__item-info">' +
        '<p class="search-instant-dropdown__item-title">' + escapeHtml(product.title) + '</p>' +
        (priceHtml ? '<div class="search-instant-dropdown__item-price">' + priceHtml + '</div>' : '') +
        '</div>' +
        '</a>';

      resultsContainer.insertAdjacentHTML('beforeend', itemHtml);
    });

    if (products.length > 0) {
      var viewAllUrl = (window.routes ? window.routes.search_url : '/search') +
        '?type=product&sort_by=best-selling&options%5Bfields%5D=title,tag,vendor,product_type,variants.title,variants.sku&options%5Bunavailable_products%5D=last&options%5Bprefix%5D=last&q=' +
        encodeURIComponent(query);
      var viewAllLink = footerEl.querySelector('.search-instant-dropdown__view-all');
      if (viewAllLink) viewAllLink.href = viewAllUrl;
      footerEl.style.display = 'block';
    } else {
      footerEl.style.display = 'none';
    }

    openDropdown(dropdown);
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = Number(cents) / 100;
    if (isNaN(value)) return '';

    var fmt = (window.themeGlobalVariables && window.themeGlobalVariables.settings && window.themeGlobalVariables.settings.money_format)
      || (window.cartStrings && window.cartStrings.money_format)
      || 'R$ {{amount_with_comma_separator}}';
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(Number(cents), fmt);
    }

    var amount = value.toFixed(2).replace('.', ',');
    return 'R$ ' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function showLoading(dropdown) {
    dropdown.style.display = 'block';
    dropdown.querySelector('.search-instant-dropdown__loading').style.display = 'block';
    dropdown.querySelector('.search-instant-dropdown__empty').style.display = 'none';
    dropdown.querySelector('.search-instant-dropdown__footer').style.display = 'none';
    var resultsSection = dropdown.querySelector('.search-instant-dropdown__section--results');
    if (resultsSection) resultsSection.style.display = 'none';
  }

  function openDropdown(dropdown) {
    dropdown.style.display = 'block';
  }

  function closeDropdown(dropdown) {
    dropdown.style.display = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('.search__input')) {
            init();
          }
        });
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  /* Expose fallback helpers for the native search IIFE */
  window._searchFallback = {
    load: loadFallbackIndex,
    search: searchFallback,
    merge: mergeLocalFallback,
    verifyCache: productVerifyCache
  };
})();

/* ── Pin products in theme native predictive search ── */
(function () {
  'use strict';

  var PIN_RULES = [
    { term: 'cadeira de banho', handle: 'cadeira-de-banho-simples-sc103-aco-desmontavel-com-rodizios-100kg-hidrolight' }
  ];

  var pinCardCache = {};

  function matchRule(query) {
    var q = query.toLowerCase().trim();
    for (var i = 0; i < PIN_RULES.length; i++) {
      if (q.indexOf(PIN_RULES[i].term) !== -1) return PIN_RULES[i];
    }
    return null;
  }

  function fetchAndPin(handle) {
    var resultsList = document.querySelector('#search-results-list');
    if (!resultsList) return;

    // Already pinned?
    if (resultsList.querySelector('[data-pinned="' + handle + '"]')) return;

    // Already in results? Move to top
    var existing = resultsList.querySelector('a[href*="/products/' + handle + '"]');
    if (existing) {
      var card = existing.closest('.product-item');
      if (card && card !== resultsList.firstElementChild) {
        card.setAttribute('data-pinned', handle);
        resultsList.insertBefore(card, resultsList.firstElementChild);
      }
      return;
    }

    // Use cached card HTML
    if (pinCardCache[handle]) {
      insertCard(resultsList, pinCardCache[handle], handle);
      return;
    }

    // Fetch the product card via section rendering
    var url = '/search/suggest?q=' + encodeURIComponent(handle.replace(/-/g, ' ')) +
      '&resources[type]=product&resources[limit]=1' +
      '&resources[options][fields]=title,tag,vendor,product_type,variants.title,variants.sku' +
      '&resources[options][prefix]=last&resources[options][unavailable_products]=last' +
      '&section_id=search-predictive-grid';

    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.product-item');
        if (!card) return;
        pinCardCache[handle] = card.outerHTML;
        var rl = document.querySelector('#search-results-list');
        if (rl && !rl.querySelector('[data-pinned="' + handle + '"]')) {
          insertCard(rl, card.outerHTML, handle);
        }
      })
      .catch(function () { /* produto não encontrado ou rede falhou — ignora silenciosamente */ });
  }

  function insertCard(resultsList, cardHtml, handle) {
    if (!resultsList || !cardHtml) return;
    var wrapper = document.createElement('div');
    wrapper.innerHTML = cardHtml;
    var card = wrapper.firstElementChild;
    if (card) {
      card.setAttribute('data-pinned', handle);
      resultsList.insertBefore(card, resultsList.firstElementChild);
    }
  }

  /* ── Exact-match boost: fetch results with quoted query and merge ── */
  function needsExactBoost(query) {
    var q = query.trim();
    // Boost when query has a short alphanumeric token (model codes like d30, sc103)
    var tokens = q.split(/\s+/);
    return tokens.some(function (t) {
      return /^[a-zA-Z]?\d+[a-zA-Z]?\d*$/.test(t) && t.length <= 8;
    });
  }

  function exactBoost(query) {
    var resultsList = document.querySelector('#search-results-list');
    if (!resultsList) return;

    var sectionId = 'search-predictive-grid';
    var url = (window.routes && window.routes.predictive_search_url || '/search/suggest') +
      '?q=' + encodeURIComponent('"' + query.trim() + '"') +
      '&resources[type]=product&resources[limit]=5' +
      '&resources[options][fields]=title,tag,vendor,product_type,variants.title,variants.sku' +
      '&resources[options][prefix]=last&resources[options][unavailable_products]=last' +
      '&section_id=' + sectionId;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var exactCards = doc.querySelectorAll('.product-item');
        if (!exactCards.length) return;

        var rl = document.querySelector('#search-results-list');
        if (!rl) return;

        // Collect handles already present
        var existingHandles = {};
        rl.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
          var h = a.getAttribute('href').replace(/.*\/products\//, '').split('?')[0];
          existingHandles[h] = true;
        });

        // Insert exact-match cards at the top (in reverse to preserve order)
        var toInsert = [];
        exactCards.forEach(function (card) {
          var link = card.querySelector('a[href*="/products/"]');
          if (!link) return;
          var handle = link.getAttribute('href').replace(/.*\/products\//, '').split('?')[0];
          if (existingHandles[handle]) {
            // Already present — remove from current position to re-add at top
            var existing = rl.querySelector('a[href*="/products/' + handle + '"]');
            if (existing) {
              var existingCard = existing.closest('.product-item');
              if (existingCard) existingCard.remove();
            }
          }
          toInsert.push(card);
        });

        // Insert in reverse order so first card ends up first
        for (var i = toInsert.length - 1; i >= 0; i--) {
          rl.insertBefore(toInsert[i], rl.firstElementChild);
        }
      })
      .catch(function () {});
  }

  /* ── Native fallback: inject local-index products into the native grid ── */
  function nativeFallback(query) {
    if (!window._searchFallback) return;
    var resultsList = document.querySelector('#search-results-list');
    if (!resultsList) return;

    window._searchFallback.load(function (index) {
      var localResults = window._searchFallback.search(index, query);
      if (!localResults.length) return;

      var rl = document.querySelector('#search-results-list');
      if (!rl) return;

      var existingHandles = {};
      rl.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        var h = a.getAttribute('href').replace(/.*\/products\//, '').split('?')[0];
        existingHandles[h] = true;
      });

      var totalItems = rl.querySelectorAll('.product-item').length;

      localResults.forEach(function (product) {
        if (totalItems >= 5) return;
        if (existingHandles[product.handle]) return;
        // Skip fallback entries without image or price (drafts, invalid)
        if (!product.image || !product.price) return;

        // Verify product is not a draft using shared cache
        var handle = product.handle;
        var vCache = window._searchFallback ? window._searchFallback.verifyCache : {};
        if (vCache[handle] === null) return; // Known draft — skip
        if (vCache[handle] !== undefined && vCache[handle].image) {
          product.image = vCache[handle].image;
        }

        var imgSrc = product.image || '';
        if (imgSrc && imgSrc.indexOf('_120x') === -1) {
          imgSrc = imgSrc.replace(/(\.[^.?]+)(\?.*)?$/, '_120x$1$2');
        }

        var price = Number(product.price || 0);
        var pixPrice = (price * 0.9);
        var fmt = function (n) {
          return 'R$ ' + n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        };
        var isFallbackSoldOut = product.available === false;

        var fallbackPriceHtml = '';
        if (isFallbackSoldOut) {
          fallbackPriceHtml = '<span style="font-size:11px;font-weight:600;text-transform:uppercase;color:#fff;background:#999;border-radius:3px;padding:1px 6px">Esgotado</span>';
        } else {
          fallbackPriceHtml = '<strong style="color:#16a34a">' + fmt(pixPrice) + '</strong><small style="opacity:.6;margin-left:3px">à vista</small>';
        }

        var cardHtml = '<div class="product-item" data-fallback="' + product.handle + '">' +
          '<a href="' + product.url + '" class="product-item__link">' +
          '<div class="product-item__image">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="" loading="lazy" width="80" height="80">' : '') +
          '</div>' +
          '<div class="product-item__info">' +
          '<p class="product-item__title">' + product.title + '</p>' +
          '<div class="product-item__price">' + fallbackPriceHtml +
          '</div></div></a></div>';

        rl.insertAdjacentHTML('beforeend', cardHtml);
        totalItems++;
        existingHandles[product.handle] = true;
      });
    });
  }

  // Monkey-patch BlsSearchShopify.renderSearchResults
  function patchSearch() {
    if (typeof BlsSearchShopify === 'undefined') return false;
    if (BlsSearchShopify._pinPatched) return true;

    var original = BlsSearchShopify.renderSearchResults;
    BlsSearchShopify.renderSearchResults = function (resultsMarkup) {
      original.call(this, resultsMarkup);
      var input = document.querySelector('input[type="search"]');
      if (input) {
        var query = input.value;
        // Exact-match boost for model codes
        if (needsExactBoost(query)) exactBoost(query);
        // Pin specific products
        var rule = matchRule(query);
        if (rule) fetchAndPin(rule.handle);
        // Local fallback for missing products
        nativeFallback(query);
      }
    };
    BlsSearchShopify._pinPatched = true;
    return true;
  }

  // Try to patch immediately, or wait for it
  if (!patchSearch()) {
    var checkInterval = setInterval(function () {
      if (patchSearch()) clearInterval(checkInterval);
    }, 200);
    // Stop trying after 10s
    setTimeout(function () { clearInterval(checkInterval); }, 10000);
  }
})();

/* ── Fallback for full search results page — REMOVED ──
   Cards clonados herdavam vendor/preço do template (bug de marca e layout).
   Resultados da página /search agora são 100% do Shopify. ── */

/* ── Pin products on full search results page (/search?q=...) ── */
(function () {
  'use strict';

  var FULL_PAGE_PINS = {
    'cadeira de banho': 'cadeira-de-banho-simples-sc103-aco-desmontavel-com-rodizios-100kg-hidrolight'
  };

  function run() {
    if (window.location.pathname !== '/search') return;
    var params = new URLSearchParams(window.location.search);
    var query = (params.get('q') || '').toLowerCase().trim();
    if (!query) return;

    var handle = null;
    var keys = Object.keys(FULL_PAGE_PINS);
    for (var i = 0; i < keys.length; i++) {
      if (query.indexOf(keys[i]) !== -1) { handle = FULL_PAGE_PINS[keys[i]]; break; }
    }
    if (!handle) return;

    var grid = document.querySelector('#product-grid');
    if (!grid) return;

    // Already in results? Move to top
    var existing = grid.querySelector('a[href*="/products/' + handle + '"]');
    if (existing) {
      var card = existing.closest('.grid__item');
      if (card && card !== grid.firstElementChild) {
        grid.insertBefore(card, grid.firstElementChild);
      }
      return;
    }

    // Fetch real card via Shopify section rendering
    var url = '/search?q=' + encodeURIComponent(handle.replace(/-/g, ' ')) +
      '&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last' +
      '&section_id=main-search';

    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('a[href*="/products/' + handle + '"]');
        if (!card) return;
        var gridItem = card.closest('.grid__item');
        if (!gridItem) return;

        var g = document.querySelector('#product-grid');
        if (!g || g.querySelector('a[href*="/products/' + handle + '"]')) return;
        g.insertBefore(gridItem, g.firstElementChild);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
